import FindingReservationTipsModal from './FindingReservationTipsModal';

export default FindingReservationTipsModal;
